import type { AdminMediaItem } from '@/lib/api'
import RowActions from '@/components/RowActions'
import { normalizeImageKitUrl } from '@lic/media-urls'

const badgeStyle: Record<string, string> = {
  MV: 'bg-pink-500/20 text-pink-300',
  LIVE: 'bg-blue-500/20 text-blue-300',
  BEHIND: 'bg-yellow-500/20 text-yellow-300',
}

export default function MediaCard({
  item,
  onView,
  onEdit,
  onDelete,
}: {
  item: AdminMediaItem
  onView: () => void
  onEdit: () => void
  onDelete: () => void
}) {
  return (
    <div
      className="rounded-xl overflow-hidden border border-zinc-800 hover:border-zinc-700 cursor-pointer transition-all group"
      onClick={onView}
    >
      <div className="aspect-video relative overflow-hidden bg-zinc-800">
        {item.image_url ? (
          <img
            src={normalizeImageKitUrl(item.image_url)}
            alt={item.alt}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            onError={(e) => { (e.target as HTMLImageElement).src = '/images/placeholder.jpg' }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-zinc-800">
            <span className="text-zinc-600 text-3xl font-bold">{item.title[0]}</span>
          </div>
        )}

        {item.duration && (
          <div className="absolute bottom-1.5 right-1.5 bg-black/60 text-white text-[10px] px-1.5 py-0.5 rounded">
            {item.duration}
          </div>
        )}

        <div className="absolute top-1.5 right-1.5" onClick={(e) => e.stopPropagation()}>
          <RowActions
            triggerClassName="flex items-center justify-center w-7 h-7 rounded bg-black/20 hover:bg-black/40 backdrop-blur-sm text-white/80 hover:text-white transition-colors"
            actions={[
              { label: 'Edit', onClick: onEdit },
              { label: 'Hapus', onClick: onDelete, variant: 'danger' },
            ]}
          />
        </div>
      </div>

      <div className="p-3">
        <div className="flex items-start gap-1.5 mb-1">
          <span className={`text-[10px] tracking-wide px-1.5 py-0.5 rounded font-medium flex-shrink-0 mt-0.5 ${badgeStyle[item.badge] ?? 'bg-zinc-800 text-zinc-300'}`}>
            {item.badge}
          </span>
          <p className="text-white text-sm font-medium leading-snug line-clamp-2 min-w-0">
            {item.title}
          </p>
        </div>
        <p className="text-zinc-500 text-xs">{item.date}</p>
        {item.is_featured && (
          <p className="text-yellow-400 text-[11px] mt-0.5">Featured</p>
        )}
      </div>
    </div>
  )
}
